export default {
    /**
     * Onetime indicators
     **/
    // Underlying Risks
    indicator_1: 'High risk',
    indicator_2: 'Current smoker',
    indicator_3: 'Chronic condition',
    indicator_4: 'Senior citizen (age 65+)',

    // Vaccines
    indicator_5: 'Flu vaccine',
    indicator_6: 'Covid vaccine',

    // Behavioural Risks
    indicator_7: 'Safe behaviors',
    indicator_8: 'Stayed home',
    indicator_9: 'Face mask',
    indicator_10: 'Wash hands',
    indicator_11: 'Clean space',

    /**
     * Timeline indicators
     **/
    indicator_12: 'Daily Temperature',
    indicator_13: 'Daily Reported Symptoms',
    indicator_14: 'Daily Blood Oxygen Saturation',
};
